import React, { useRef, useState, useContext } from 'react';

import { Box } from '@mui/material';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

import { useSelector, useDispatch } from 'react-redux';
import { getRepository } from 'src/actions/repositoryActions';

import { DashboardContext } from 'src/context/DashboardContext';
import { clearDocuments } from 'src/actions/documentActions';

function RepoList() {
  const {
    setSearchPerformed,
    checkedDocuments,
    setDocSearchFields,
    setActiveTab
  } = useContext(DashboardContext);

  const dispatch = useDispatch();

  const ref = useRef(null);

  const repositories = useSelector((state) => state.repository.list);
  const selectedRepo = useSelector((state) => state.repository.selected);
  const [inputValue, setInputValue] = useState('');

  const handleSelectRepo = (repo) => {
    setDocSearchFields([]);
    dispatch(getRepository(repo.id));
    setSearchPerformed(false);
    setActiveTab(0);

    // - we put clear docs here because if we only want to
    //   clear docs when the repo changes if it were in handleSelectRepo it would
    //   cause a clear even when the user chooses the same repo
    if (repo.id !== selectedRepo.id) {
      dispatch(clearDocuments());
    }
  };

  const repoName = (repo) => {
    if (!repo.options || !repo.options.displayName || repo.options.displayName.length === 0) {
      return repo.name;
    }
    return repo.options.displayName;
  };

  return (
    <>
      <Box
        display="flex"
        alignItems="center"
        ref={ref}
      >
        <Autocomplete
          disabled={checkedDocuments && !!checkedDocuments.length}
          filterSelectedOptions={false}
          value={repositories.find((repo) => repo.id === selectedRepo.id) || { name: '', id: '' }}
          onChange={(event, newValue) => {
            if (newValue) {
              handleSelectRepo(newValue);
            }
          }}
          getOptionLabel={(option) => repoName(option)}
          inputValue={inputValue}
          onInputChange={(event, newInputValue) => {
            setInputValue(newInputValue);
          }}
          id="selected-repository-select"
          options={repositories}
          style={{ width: 300, padding: '0px 10px' }}
          renderInput={(params) => (
            <TextField {...params} InputProps={{ ...params.InputProps, disableUnderline: true }} variant="standard" size="small" />
          )}
        />
      </Box>
    </>
  );
}

export default RepoList;
